import React from "react";
import { Container, Grid, Box } from "@mui/material";
import ResetPasswordComp from "../../components/authcomponents/ResetPasswordComp";

const ResetPassWord = () => {
  return (
    <Container
      maxWidth="xl"
      disableGutters
      sx={{
        pt: 6,
        // border:{xs:'',sm:'2px solid gray'} ,
        position: "relative",
        overflow: "visible",
        background: "white",
      }}
    >
      {/* Right Top */}
      <Box
        sx={{
          position: "absolute",
          top: { xs: 280, sm: 12 },
          left: "calc(100% - 235px)",
          transform: "translateX(50%)",
          zIndex: "5",
          width: { xs: "50px", sm: "100px", md: "140px" },
          height: { xs: "50px", sm: "100px", md: "140px" },
        }}
      >
        <img
          src="/assets/Polygon2.png"
          alt="Polygon2"
          style={{
            width: "100%",
            height: "100%",
            transform: "rotate(72deg)",
          }}
        />
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: { xs: 120, sm: 80 },
          left: "calc(100% - 320px)",
          transform: "translateX(50%)",
          width: { xs: "40px", sm: "80px", md: "110px" },
          height: { xs: "40px", sm: "80px", md: "110px" },
        }}
      >
        <img
          src="/assets/Polygon2.png"
          alt="Polygon"
          style={{
            width: "100%",
            height: "100%",
            transform: "rotate(80deg)",
          }}
        />
      </Box>

      {/* Left Bottom */}
      <Box
        sx={{
          position: "absolute",
          bottom: { xs: 180, sm: 0 },
          left: 66,
          transform: "translateX(-50%)",
          zIndex: 10,
          width: { xs: "40px", sm: "80px", md: "120px" },
          height: { xs: "40px", sm: "80px", md: "120px" },
        }}
      >
        <img
          src="/assets/Polygon2.png"
          alt="Polygon2"
          style={{
            width: "100%",
            height: "100%",
            transform: "rotate(-10deg)",
          }}
        />
      </Box>
      <Box
        sx={{
          position: "absolute",
          bottom: { xs: 180, sm: 130 },
          left: 150,
          transform: "translateX(-50%)",
          zIndex: 10,
          width: { xs: "30px", sm: "50px", md: "70px" },
          height: { xs: "30px", sm: "50px", md: "70px" },
        }}
      >
        <img
          src="/assets/Polygon2.png"
          alt="Polygon2"
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      </Box>

      {/* Left Top */}
      <Box
        sx={{
          position: "absolute",
          top: { xs: 120, sm: 22 },
          left: { xs: 50, sm: 140 },
          transform: "translateX(-50%)",
          zIndex: 10,
          width: { xs: "100px", sm: "150px", md: "200px" },
          height: { xs: "100px", sm: "150px", md: "200px" },
        }}
      >
        <img
          src="/assets/Ellipse2.png"
          alt="Ellipse"
          style={{
            width: "100%",
            height: "100%",
            transform: "rotate(90deg)",
          }}
        />
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: { xs: 160, sm: 200 },
          left: 230,
          transform: "translateX(-50%)",
          zIndex: 10,
          width: { xs: "40px", sm: "70px", md: "100px" },
          height: { xs: "40px", sm: "70px", md: "100px" },
        }}
      >
        <img
          src="/assets/Ellipse2.png"
          alt="Ellipse"
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: { xs: 280, sm: 240 },
          left: 35,
          transform: "translateX(-50%)",
          zIndex: 10,
          width: { xs: "20px", sm: "40px", md: "60px" },
          height: { xs: "20px", sm: "40px", md: "60px" },
        }}
      >
        <img
          src="/assets/Ellipse2.png"
          alt="Ellipse"
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      </Box>

      {/* Right Bottom */}
      <Box
        sx={{
          position: "absolute",
          bottom: { xs: 120, sm: 12 },
          right: { xs: -40, sm: -70 },
          transform: "translateX(-50%)",
          zIndex: 10,
          width: { xs: "100px", sm: "140px", md: "180px" },
          height: { xs: "100px", sm: "140px", md: "180px" },
        }}
      >
        <img
          src="/assets/Ellipse2.png"
          alt="Ellipse"
          style={{
            width: "100%",
            height: "100%",
            transform: "rotate(270deg)",
          }}
        />
      </Box>
      <Box
        sx={{
          position: "absolute",
          bottom: { xs: 120, sm: 170 },
          right: 175,
          transform: "translateX(-50%)",
          zIndex: 10,
          width: { xs: "40px", sm: "70px", md: "100px" },
          height: { xs: "40px", sm: "70px", md: "100px" },
        }}
      >
        <img
          src="/assets/Ellipse2.png"
          alt="Ellipse"
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      </Box>
      <Box
        sx={{
          position: "absolute",
          bottom: { xs: 180, sm: 240 },
          right: 35,
          transform: "translateX(-50%)",
          zIndex: 10,
          width: { xs: "20px", sm: "40px", md: "60px" },
          height: { xs: "20px", sm: "40px", md: "60px" },
        }}
      >
        <img
          src="/assets/Ellipse2.png"
          alt="Ellipse"
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      </Box>

      <Grid
        container
        sx={{
          minHeight: "90vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid
          item
          xs={12}
          sm={8}
          md={6}
          lg={4}
          sx={{
            py: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
          }}
        >
          <ResetPasswordComp />
        </Grid>
      </Grid>
    </Container>
  );
};

export default ResetPassWord;
